import Phaser from "phaser";
import BootScene from "./scenes/BootScene.js";
import MenuScene from "./scenes/MenuScene.js";
import GameScene from "./scenes/GameScene.js";
import VictoryScene from "./scenes/VictoryScene.js";
import DefeatScene from "./scenes/DefeatScene.js";
import FinalVictoryScene from "./scenes/FinalVictoryScene.js";

const config = {
  type: Phaser.AUTO,
  scale: {
    mode: Phaser.Scale.FIT,
    parent: "game-container",
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 800,
    height: 600,
  },
  backgroundColor: "#2d5016",
  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    MenuScene,
    GameScene,
    VictoryScene,
    DefeatScene,
    FinalVictoryScene,
  ],
};

const game = new Phaser.Game(config);

export default game;
